import classnames from "classnames";
import React, { ComponentType, FC, memo } from "react";

import { testAttr } from "@/browser";

import { Flex } from "../../../Flex";
import { IDataTableProps, THeaderCellComponent } from "../../types";
import { HeaderCell as HeaderCellBase } from "../HeaderCellComponent";
import { ExpandCell as ExpandCellComponentBase, IExpandCellProps } from "./ExpandCell";

export interface IHeaderComponentProps
  extends Pick<IDataTableProps, "columns" | "testName">,
    Pick<IExpandCellProps, "expandAllIcon" | "collapseAllIcon"> {
  allRowsExpanded: boolean;
  className?: string;
  expandable: boolean;
  HeaderCellComponent?: THeaderCellComponent;
  ExpandCellComponent?: ComponentType<IExpandCellProps>;
  onToggleExpandClick: () => void;
}

const HeaderComponentBase: FC<IHeaderComponentProps> = ({
  allRowsExpanded,
  className,
  collapseAllIcon,
  columns,
  expandable,
  expandAllIcon,
  HeaderCellComponent,
  ExpandCellComponent,
  onToggleExpandClick,
  ...rest
}) => {
  const HeaderCell = HeaderCellComponent ? HeaderCellComponent : HeaderCellBase;
  const ExpandCell = ExpandCellComponent ? ExpandCellComponent : ExpandCellComponentBase;

  const classNames = classnames("data-table__header-row", className);
  const testableProps = testAttr(rest, { sufix: "data-table__header" });

  return (
    <Flex className={classNames} {...testableProps}>
      {columns.map((column, i) => {
        const { key = "HCell" } = column;
        return <HeaderCell key={`${key}-${i}`} {...column} />;
      })}
      {expandable ? (
        <ExpandCell
          allExpanded={allRowsExpanded}
          onToggleExpandClick={onToggleExpandClick}
          expandAllIcon={expandAllIcon}
          collapseAllIcon={collapseAllIcon}
        />
      ) : null}
    </Flex>
  );
};

export const HeaderComponent = memo(HeaderComponentBase);
